import ArtistArtworks from './ArtistArtworks'

export default ArtistArtworks
